// material-ui
import { createTheme } from '@mui/material'

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette() {
    return createTheme({
        palette: {
            common: {
                black: '#000000',
                white: '#FFFFFF',
            },
            mode: 'light',
            primary: {
                main: '#01cdcb',
                contrastText: 'rgba(255,255,255,1)',
                dark: '#01cdcb',
            },
            secondary: {
                light: 'rgba(0, 233, 198, 0.16)',
                main: 'rgba(0, 233, 198, 0.16)',
                dark: 'rgba(0, 233, 198, 0.16)',
                contrastText: '#01CDCB',
            },
            error: {
                backgroundError: '#FFDCDC',
                contrastText: '#FFFFFF',
                dark: '#C62828',
                light: '#FCE7E7',
                main: '#E53935',
            },
            grey: {
                grey500: '#9E9E9E',
                backgroundDark: '#E8E8E8',
                backgroundMain: '#F2F5F8',
                backgroundLight: '#E5E5E5',
                greyDisable: '#C4C4C4',
                greyDivider: '#E5E5E5',
                greyDark: 'rgba(0, 0, 0, 0.24)',
                greyLight: 'rgba(0, 0, 0, 0.04)',
                greyInactive: 'rgba(0, 0, 0, 0.54)',
                greyMediumEmphasis: 'rgba(0, 0, 0, 0.6)',
                greyHighEmphasis: 'rgba(0, 0, 0, 0.87)',
                greyRgba45: 'rgba(0, 0, 0, 0.45)',
                greyRgba12: 'rgba(0, 0, 0, 0.12)',
                greyRgba85: 'rgba(0, 0, 0, 0.85)',
            },
            black: {
                inactive: 'rgba(0, 0, 0, 0.54)',
            },
            header: {
                bg: '#F2F5F8',
                border: '#FFFFFF',
            },
            navTab: {
                bg: '#F2F5F8',
                border: '#E5E5E5',
            },
            dataPiker: {
                bgInputDefault: 'rgba(245, 245, 245, 1)',
                colorInputDefault: 'rgba(0, 0, 0, 0.6)',
                colorInputFocus: 'rgba(0, 0, 0, 1)',
            },
        },
    })
}
